import { Styles } from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core";

export const style: Styles<Theme, {}> = theme => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: "16px",
        position: "fixed",
        right: "0px",
        top: "0px",
        zIndex: 99999,
    }
});
